export default __webpack_public_path__ + "static/media/rocket.9c8b76fd.png";